/* istanbul ignore file */
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const ContractCountryBadge = ({ text, ...props }: FieldBadgeProps) => (
  <Badge color="default" sx={{ ml: 1 }} {...props}>
    {text}
  </Badge>
);

export default ContractCountryBadge;
